import { HalfTimeFullTimeEnum } from "../../Enums/ValueEnums";

export default class ValueHalfTimeFullTime {
    public value: HalfTimeFullTimeEnum = null;
}